import { useNavigate } from 'react-router-dom'
import { useYearStore } from '@/components/DropdownYear'
import { Button } from '@/components/ui/button'
import { Settings } from 'lucide-react'
import dayjs from 'dayjs'
import VisibleDateTrackerCell from '@/components/roi/VisibleDateTrackerCell'
import { collectBaselineChangesForDate } from '@/components/roi/day-roas-utils'
import { renderBaselineChangeTooltipLines } from '@/components/roi/day-roas-columns'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'

const getDaysInMonth = (monthId) => {
  const month = dayjs(monthId, 'YYYYMM')
  const daysInMonth = month.daysInMonth()
  const days = []
  for (let i = 1; i <= daysInMonth; i++) {
    days.push(month.date(i).format('YYYYMMDD'))
  }
  return days
}

export const CreateDateColumn = ({
  row,
  country,
  drBaselines,
  pidForBaseline,
  costBaselines,
  profitBaselines,
  packageName = null,
}) => {
  const navigate = useNavigate()
  const month = row.original.month
  const monthId = row.original.monthId
  const year = useYearStore((state) => state.value)

  const handleGoalSettings = () => {
    const month = monthId.substring(4, 6)
    navigate(`/roi/monthly/goals?year=${year}&month=${month}`)
  }

  const daysInMonth = getDaysInMonth(monthId)
  const representativeDate = daysInMonth[daysInMonth.length - 1]

  const changesInMonth = []
  daysInMonth.forEach((day) => {
    const dateFormatted = dayjs(day, 'YYYYMMDD').format('YYYY-MM-DD')
    const prevDate = dayjs(day, 'YYYYMMDD')
      .subtract(1, 'day')
      .format('YYYYMMDD')

    const changeInfo = collectBaselineChangesForDate({
      dateFormatted,
      dayValue: day,
      prevDateValue: prevDate,
      drBaselines,
      country,
      pidForBaseline,
      packageName,
      costBaselines,
      profitBaselines,
    })

    if (changeInfo) {
      changesInMonth.push(changeInfo)
    }
  })
  const hasChange = changesInMonth.length > 0

  return (
    <VisibleDateTrackerCell date={representativeDate}>
      <div className="relative pl-5 flex items-center space-x-2 text-left">
        {hasChange && (
          <TooltipProvider delayDuration={0}>
            <Tooltip>
              <TooltipTrigger asChild>
                <div className="absolute bottom-1 left-1 w-3 h-3 bg-green-500 rounded-full" />
              </TooltipTrigger>
              <TooltipContent>
                <p>Baseline Changed:</p>
                {changesInMonth.map((change) => (
                  <div key={change.date}>
                    <strong>On {change.date}:</strong>
                    {renderBaselineChangeTooltipLines(change)}
                  </div>
                ))}
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}
        <div>{month}</div>
        <Button
          variant="ghost"
          size="icon"
          onClick={handleGoalSettings}
          title="Goal Settings"
          className="h-7 w-7 p-0"
        >
          <Settings className="h-4 w-4" />
        </Button>
      </div>
    </VisibleDateTrackerCell>
  )
}
